<template>
  <el-row>
    <el-col :span="24">
      <el-card v-loading="loading">
        <div class="data-title flex-space-between" slot="header">
          <p>Import Tracks Admin</p>
          <div>
            <el-button type="success" class="btn-main" @click="publishAll">
              Publish all tracks
            </el-button>
            <DialogTrack page="admin"/>
          </div>
        </div>
        <el-table :data="data" class="w100" stripe>
          <el-table-column width="100%">
            <template slot-scope="props">
              <img
                  v-if="props.row.image_url"
                  class="avatar"
                  :src="props.row.image_url"
              />
              <img
                  v-else
                  class="avatar"
                  :src="`https://app.syncvault.com/static/apple-touch-icon.png`"
              />
            </template>
          </el-table-column>
          <el-table-column
            label="Title"
            prop="title"
            sortable
          ></el-table-column>
          <el-table-column
            label="Artist"
            prop="artist.name"
            sortable
          ></el-table-column>
          <el-table-column
            label="Length"
            prop="song_length"
            sortable
          ></el-table-column>
          <el-table-column
            label="File name"
            prop="original_file_name"
            sortable
          >
            <template slot-scope="props">
              <span class="download_track" @click="downloadFile(props.row)">{{ props.row.original_file_name}}</span>
            </template>>

          </el-table-column>
          <el-table-column label="Timing period" width="250%">
            <template slot-scope="props">
              <span v-if="props.row.timing_start">
                {{ props.row.timing_start | day_month }} -
                {{ props.row.timing_end | date }}
              </span>
              <span v-else>Timing not set</span>
            </template>
          </el-table-column>
          <el-table-column label="Actions" align="right">
            <template slot-scope="props">
              <el-tooltip content="Publish" placement="top">
                <el-button
                  type="success"
                  circle
                  size="small"
                  icon="el-icon-top"
                  @click="publish(props.row.id)"
                ></el-button>
              </el-tooltip>
              <el-tooltip content="Edit" placement="top">
                <el-button
                    type="warning"
                    circle
                    size="small"
                    icon="el-icon-edit"
                    @click="openEdit(props.row)"
                ></el-button>
              </el-tooltip>
              <el-tooltip content="Delete" placement="top">
                <el-button
                  type="danger"
                  circle
                  size="small"
                  icon="el-icon-close"
                  @click="deleteT(props.row.id)"
                ></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import DialogTrack from './DialogTrack'
import axios from "@/plugins/axios";

export default {
  data() {
    return {
      baseURL: process.env.VUE_APP_ADMIN_API_URL,
    }
  },

  components: {
    DialogTrack
  },

  computed: {
    ...mapState('trackImport', ['loading', 'data'])
  },

  methods: {
    ...mapActions('trackImport', [
      'readAdmin',
      'adminPublish',
      'deleteTrackAdmin',
      'downloadTrack'
    ]),
    ...mapMutations('trackImport', [
      'setTrack',
      'setDialogTrack',
      'setGenres',
      'setMoods',
      'setRestrictions'
    ]),

    publish(id) {
      this.$confirm('You will publish this track. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
        .then(() => {
          this.adminPublish(id)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Publish cancelled'
          })
        })
    },

    publishAll() {
      this.$confirm('You will publish tracks. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
        .then(() => {
          this.adminPublish()
          this.$message({
            type: 'success',
            message: 'Publish completed'
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Publish cancelled'
          })
        })
    },

    deleteT(id) {
      this.$confirm(
        'You will permanently delete this track. Continue?',
        'Warning',
        {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }
      )
        .then(() => {
          this.deleteTrackAdmin(id)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete cancelled'
          })
        })
    },

    downloadFile(track){
      this.downloadTrack(track.id)
    },

    openEdit(track) {
      if (track.short_challenge.budget > 0) track.short_challenge.budget = track.short_challenge.budget / 10;
      if (track.short_challenge.guaranteed_payment > 0) track.short_challenge.guaranteed_payment = track.short_challenge.guaranteed_payment / 10;
      if (track.short_challenge.bonus_payment > 0) track.short_challenge.bonus_payment = track.short_challenge.bonus_payment / 10;

      if (track.tiktok_challenge.budget > 0) track.tiktok_challenge.budget = track.tiktok_challenge.budget / 10;
      if (track.tiktok_challenge.guaranteed_payment > 0) track.tiktok_challenge.guaranteed_payment = track.tiktok_challenge.guaranteed_payment / 10;
      if (track.tiktok_challenge.bonus_payment > 0) track.tiktok_challenge.bonus_payment = track.tiktok_challenge.bonus_payment / 10;

      if (track.instagram_challenge.budget > 0) track.instagram_challenge.budget = track.instagram_challenge.budget / 10;
      if (track.instagram_challenge.guaranteed_payment > 0) track.instagram_challenge.guaranteed_payment = track.instagram_challenge.guaranteed_payment / 10;
      if (track.instagram_challenge.bonus_payment > 0) track.instagram_challenge.bonus_payment = track.instagram_challenge.bonus_payment / 10;
      this.setDialogTrack(true)
      this.setTrack(JSON.parse(JSON.stringify(track)))
    },
  },

  async created() {
    this.readAdmin()

    let genres = await axios.api.get('/genres')
    if (genres.data.success) this.setGenres(genres.data.genres)

    let moods = await axios.api.get('/moods')
    if (moods.data.success) this.setMoods(moods.data.moods)

    let restrictions = await axios.api.get('/restrictions')
    if (restrictions.data.success) this.setRestrictions(restrictions.data.restrictions)
  },
}
</script>

<style lang="scss" scoped>
.download_track {
  cursor: pointer;
}
</style>
